'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const dateformat=require('dateformat');
const TickIncrementCalculator=require('../../../../dist-es6/client/directives/plotting/tickIncrementCalculator');let

RouteGraphDirective=function(_BaseControllerBacked){_inherits(RouteGraphDirective,_BaseControllerBacked);function RouteGraphDirective(){_classCallCheck(this,RouteGraphDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(RouteGraphDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/routeGraphDirective/routeGraphTemplate'}},{key:'objectBindings',get:function()
{return['scenarioBounds','schedule','route','fatigueThreshold','overallTrip']}},{key:'controller',get:function()
{return RouteGraphDirectiveController}}]);return RouteGraphDirective}(BaseControllerBackedDirective);let


RouteGraphDirectiveController=function(){
function RouteGraphDirectiveController(){_classCallCheck(this,RouteGraphDirectiveController);
this.elementBindings={};
this._tickIncrementCalculator=new TickIncrementCalculator(TickIncrementCalculator.DefaultScales.slice(3));
}RouteGraphDirectiveController.prototype.

topmostTextTickProvider=function topmostTextTickProvider(axis){
let idealTicks=this.dimensions.width/(8*60);
let tickIncrements=this._tickIncrementCalculator.calculate(axis.domain.duration,idealTicks);
return{
type:'d3Calculated',
interval:tickIncrements.minor.interval,
step:tickIncrements.minor.step};

};RouteGraphDirectiveController.prototype.

topmostTextTickFormatter=function topmostTextTickFormatter(date){
return dateformat(date,'ddd, mmm d');
};RouteGraphDirectiveController.prototype.

hosTextTickProvider=function hosTextTickProvider(axis){
return{
type:'values',
values:[3,2,1,0]};

};RouteGraphDirectiveController.prototype.

hosTextTickFormatter=function hosTextTickFormatter(value){
switch(value){
case 0:
return'Off Duty';
case 1:
return'Sleeper';
case 2:
return'Driving';
case 3:
return'On Duty';}

};return RouteGraphDirectiveController}();


module.exports=RouteGraphDirective;
//# sourceMappingURL=routeGraphDirective.js.map
